// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3sivY","table":"Table_table__2J4de","tableHeader":"Table_tableHeader__21jgV","tableRow":"Table_tableRow__cCyBz","message":"Table_message__zxgzv"};